import type { DefaultSettings } from "~/models/DefaultSettings"

export const INITIAL_SETTINGS_DEFAULT_VALUES: DefaultSettings = {
    show_stock: {
        enable: false,
        cant_min: 0,
    },
    contacts: {
        logo_path: "",
        team_name: "",
        phones: [],
        email: "",
        address: "",
        whatsapp: "",
        facebook: "",
        instagram: "",
        map: "",
        coordinates: "",
        favicon_path: "",
        schedule: [],
        networks: [],
        lat: "",
        long: "",
    },
    information: {
        enable_term_conditions: false,
        enable_warranty_policy: false,
        enable_return_policy: false,
        enable_shipment_policy: false,
        enable_frequent_asks: false,
        enable_about_us: false,
    },
    system_coin: "",
    base_coin: "",
    coins_availables: [],
    store_type: "",
    system_has_point_of_sales: false,
    today: "",
}

export const useDefaultSettingsStore = defineStore("defaultSettings", {
    state: (): { settings: DefaultSettings; welcome_modal: boolean } => ({
        settings: INITIAL_SETTINGS_DEFAULT_VALUES,
        welcome_modal: true,
    }),
    actions: {
        setSettings(settings: DefaultSettings) {
            this.settings = settings
        },

        setWelcomeModal(value: boolean) {
            this.welcome_modal = value
        },
    },
})
